// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBRk0SyVGqUW232zefXeMBSLX360QxIzBE",
  authDomain: "united-investment-point.firebaseapp.com",
  projectId: "united-investment-point",
  storageBucket: "united-investment-point.firebasestorage.app",
  messagingSenderId: "680895978289",
  appId: "1:680895978289:web:e3555323e3660f5eaf2e10"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider, signInWithPopup, signInWithEmailAndPassword };
